//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Footer from './components/Footer.vue'
// import Hr from './components/Hr'
import PrimaryBtn from './components/PrimaryBtn'
// import URL from './utils/URL'

// 上线开关
const producttion = true

// 获取用户的code
// const code = URL.getQueryString('code')
const host = producttion ? 'http://m.wkbins.com/' : 'http://test.m.wkbins.com/'
const wkbInnerCode = producttion ? '148198068433580000' : '149673178664394306'

export default {
  name: 'app',
  data () {
    return {
      title: '【8.1保险节】悟空保2周年庆第二单9折专题活动',
      // openId: '',
      // appid: 'wxef64cfa3a28363ac', // 正式
      // appid: 'wx71f5c7fb1d47af54', // 测试
      appid: producttion ? 'wxef64cfa3a28363ac' : 'wx71f5c7fb1d47af54',
      showMyPriceDialog: false,
      // posterActivityId: '201707261147010', // 海报活动id
      scratchActivityId: '201707261147003', // 刮刮乐活动id
      bookingActivityId: '201707261147002', // 早订早优惠活动id
      shareDesc: '活动期间下单再赠9折通用券，全场产品即可立享折上折，机会不能错过，赶紧抢~',
      activities: [
        {
          type: 'seckill',
          title: '第二单九折',
          previewImg: 'static/images/seckill-product.png',
          rules: [
            '活动时间：8月1日-8月18日；',
            '使用规则：活动期间购买专题中任一产品（秒杀产品除外）后，即可获得9折通用券一张。该券属于通用券，可购买专题任一产品（秒杀产品除外），可参与专题产品折扣叠加。所有优惠劵一经使用，不退补，不找零；',
            '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消；',
            '使用时间：9折通用券有效时间为8月1日至8月18日。'
          ]
        },
        {
          type: 'booking',
          title: '8.1元兑换区',
          rules: [
            '活动时间：8月1日-8月18日；',
            '活动范围：7月28日至7月31日，通过8.1元参加预订活动的用户，可以在“8.1元兑换专区”参与9折优惠兑换活动，限购买成人版重疾险、少儿版重疾险产品；',
            '使用规则：未提前预订的用户，可直接购买享9折优惠；已付8.1元购买9折定向券的用户，可在产品9折基础上，叠加使用9折定向券，以及其他现金券多重优惠叠加购买；所有优惠券一经使用，不退补，不找零；',
            '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消。'
          ]
        },
        {
          type: 'scratch',
          title: '两周年专区',
          rules: [
            '活动时间：8月1日-8月18日；',
            '使用规则：用户可以在产品价格8折基础上，同时叠加使用其他现金券和通用券。所有优惠券一经使用，不退补，不找零；',
            '优惠方式：保险产品下单时需全款支付，且过犹豫期未退保，产生的优惠金额将以返现方式发送至您的悟空保账户中。关注悟空保微信公众号iwukongbao，点击“我的>个人中心>我的钱包”，请使用投保手机号登录查看返现金额，返现金额待运营人员审核通过后即可提现。如果犹豫期退保，则所有优惠券自动作废，优惠额度随即取消。'
          ]
        }
      ],
      showFixedBtn: false,
      showRules: false,
      currentRule: 0,
      bookingList: [
        {
          previewImg: 'static/images/booking_1.png',
          title: '【成人版】重疾险',
          link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/150122972795448349?requireJsApi=true&bomb=1',
          dess: [
            '覆盖上班族高发50种以上重疾，最高直降800元，确诊即赔',
            '买就送500元基因检测'
          ],
          lowestPrice: '792元/年起'
        },
        {
          previewImg: 'static/images/booking_2.png',
          title: '【少儿版】重疾险',
          link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/150122979463900132?requireJsApi=true&bomb=1',
          dess: [
            '覆盖少儿高发42种以上重疾，保障终身，确诊即赔',
            '买就送500元基因检测'
          ],
          lowestPrice: '414元/年起'
        }
      ],
      specialList: [
        {
          previewImg: 'static/images/special_1.png',
          title: '至尊保定期寿险',
          link: host + 'hengqin/#/' + wkbInnerCode + '/149674766585200396',
          dess: [
            '性价比完胜香港保险，按需灵活投保，保障最优，价格最低，后顾无忧'
          ],
          lowestPrice: '105元/年起'
        },
        {
          previewImg: 'static/images/special_2.png',
          title: '至尊保定期意外险',
          link: host + 'hqdy/#/' + wkbInnerCode + '/149792885824813849',
          dess: [
            '价格行业最低，免检保额最高、按需灵活投保，责任涵盖伤残'
          ],
          lowestPrice: '249元/年起'
        },
        {
          previewImg: 'static/images/special_3.png',
          title: '至尊保百万医疗险',
          link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149421366832021029?requireJsApi=true&bomb=1',
          dess: [
            '百万保额，百元价格，投保三年，可续保到百岁'
          ],
          lowestPrice: '117元起'
        },
        {
          previewImg: 'static/images/special_4.png',
          title: '至尊保终身寿险',
          link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149251955998404923?requireJsApi=true',
          dess: [
            '首创交至百岁,免检保额最高,价格行业最低,责任涵盖全残'
          ],
          lowestPrice: '270元/年起'
        },
        {
          previewImg: 'static/images/special_5.png',
          title: '至尊保终身意外险',
          link: host + 'activityProduct/insurePolicy/' + wkbInnerCode + '/149329577605090390?requireJsApi=true&bomb=1',
          dess: [
            '首创终身意外险, 老有所保,涵盖意外身故、全残和伤残'
          ],
          lowestPrice: '240元起'
        }
      ]
    }
  },
  computed: {
    redirectURI () {
      return host + '/anniversaries/2017/discount'
    }
  },
  components: {
    [PrimaryBtn.name]: PrimaryBtn,
    [Footer.name]: Footer
  },
  created () {
    // 微信接口权限配置
    let url = encodeURIComponent(window.location.href.replace(/#.+$/, '')) // 最后的 / 一定要有
    this.$http.get('/api/hqdqx/getJsApiInfo?projectUrl=' + url).then(response => {
      // 分享
      const shareData = {
        title: this.title,
        desc: this.shareDesc,
        // link: authorizationURL,
        imgUrl: window.location.href.replace(/#.+$/, '').replace(/\?.+$/, '') + 'static/images/share.png'
      }
      this.$wechat.ready(() => {
        // 分享给朋友
        this.$wechat.onMenuShareAppMessage({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到朋友圈
        this.$wechat.onMenuShareTimeline({
          title: shareData.title, // 分享标题
          link: shareData.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到QQ
        this.$wechat.onMenuShareQQ({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        })
        // 分享到腾讯微博
        this.$wechat.onMenuShareWeibo({
          title: shareData.title, // 分享标题
          desc: shareData.desc, // 分享描述
          link: shareData.link, // 分享链接
          imgUrl: shareData.imgUrl // 分享图标
        })
      })
      this.$wechat.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: response.data.appId, // 必填，公众号的唯一标识
        timestamp: response.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: response.data.nonceStr, // 必填，生成签名的随机串
        signature: response.data.signature, // 必填，签名，见附录1
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'onMenuShareQQ',
          'onMenuShareQZone',
          'chooseWXPay'
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      })
    })
  },
  mounted () {
    /**
     * 标题
     */
    document.title = this.title

    window.onload = () => {
      /**
       * 导航占位符的高度
       */
      window.$('.nav-placeholder').css('height', window.$('.nav-placeholder .nav').height())

      /**
       * 滚动页面
       */
      const scroller = this.$refs.scroller
      const scrollBody = scroller.getScrollBody()
      // 目标距离页面顶部的距离
      const targets = []
      window.$('.activity').each(function () {
        targets.push(window.$(this)[0].offsetTop)
      })
      // 导航的高度
      const navHeight = window.$('.nav').height()
      window.$(scrollBody).scroll(() => {
        // 当前滚动的距离
        const currentScrollTop = scroller.getScrollTop()

        // 悬浮按钮
        if (currentScrollTop >= 300) {
          this.showFixedBtn = true
        } else {
          this.showFixedBtn = false
        }

        for (let i = targets.length - 1, l = 0; i >= l; i--) {
          if (currentScrollTop < targets[0] - navHeight) {
            window.$('.nav li').removeClass('active')
            window.$('.nav li').each(function () {
              window.$(this).find('img').attr('src', window.$(this).index() % 2 === 0
              ? 'static/images/nav_odd.png'
              : 'static/images/nav_even.png')
            })
            return
          }
          if (currentScrollTop >= targets[i] - navHeight) {
            window.$('.nav li').removeClass('active')
            window.$('.nav li').eq(i).addClass('active')
            window.$('.nav li').each(function () {
              window.$(this).find('img').attr('src', window.$(this).index() % 2 === 0
              ? 'static/images/nav_odd.png'
              : 'static/images/nav_even.png')
            })
            window.$('.nav li img').eq(i).attr('src', i % 2 === 0
            ? 'static/images/nav_odd_active.png'
            : 'static/images/nav_even_active.png')
            return
          }
        }
      })
      // 点击导航
      window.$('.nav li').click(function () {
        scroller.scrollTo(targets[window.$(this).index()] - navHeight + 1)
      })
    }

    window.$(window).bind('orientationchange', () => {
      location.href = location.href
    })
  },
  methods: {
    scrollTop () {
      this.$refs.scroller.scrollTo(0)
    },
    goToBookingPage (obj, index) {
      window.location.href = this[obj][index].link
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue